import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';
import MarkdownWrapper from 'core/components/MarkdownWrapper';

import themePropTypes from 'core/utils/prop-types/theme';

import { markdownRenderers } from 'core/components/About';
import styles from './index.styl';


function CaptionGroup(props) {
  const {
    title,
    content,
    spacing,
    columns,
    theme: {
      texts,
    },
  } = props;

  return (
    <div className={styles.group}>
      <style jsx>{`
        .${styles.group}
          flex-basis ${(100 / columns) + '%'}
          padding 0 ${spacing ? `${spacing}px` : 0}

          :global(.mobile) &
            flex-basis 100%
            padding 0

        .${styles.content}
        .title
          font ${texts.body.font}

        .title
          font-weight 700
      `}</style>
      {title && <div className='title'>{title}</div>}
      {content && (
        <div className={styles.content}>
          {typeof content === 'string'
            ? <MarkdownWrapper interitemSpacing={10} components={markdownRenderers}>{content}</MarkdownWrapper>
            : content
          }
        </div>
      )}
    </div>
  );
}

CaptionGroup.defaultProps = {
  columns: 1,
};

CaptionGroup.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  /**
   * Можно управлять боковыми отступами,
   * если компонент используется в группе с другими блоками.
   */
  spacing: PropTypes.number,
  /**
   * Размер блока относительно 12 колоночного грида
   */
  columns: PropTypes.number,
  theme: themePropTypes(`
    {
      texts: {
        body: {
          font
        },
      },
    },
  `),
};

export default withTheme(CaptionGroup);
